module.exports = __webpack_public_path__ + "static/media/kpi2568.f7bcfce6.png";